export class Categorie {
    /**
     * Constructeur de la categorie
     * @param id id de l'objet
     * @param categorie à construire
     * @param typeObjet définit le type de children
     */
    constructor(id, categorie) {
        if (categorie) {
            const { idPere, libelle, ordre, nomPere } = categorie;
            this.idCategorie = id;
            this.idPere = idPere;
            this.libelle = libelle;
            this.ordre = ordre;
            this.nomPere = nomPere !== null && nomPere !== void 0 ? nomPere : null;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idCategorie: this.idCategorie,
            idPere: this.idPere,
            libelle: this.libelle,
            ordre: this.ordre,
            nomPere: this.nomPere,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2F0ZWdvcmllLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQ2F0ZWdvcmllLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sT0FBTyxTQUFTO0lBK0JyQjs7Ozs7T0FLRztJQUNILFlBQW1CLEVBQVUsRUFBRSxTQUE4QjtRQUM1RCxJQUFJLFNBQVMsRUFBRTtZQUNkLE1BQU0sRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsR0FBRyxTQUFTLENBQUM7WUFFdEQsSUFBSSxDQUFDLFdBQVcsR0FBRyxFQUFFLENBQUM7WUFDdEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7WUFDckIsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUM7WUFDdkIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7WUFDbkIsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLGFBQVAsT0FBTyxjQUFQLE9BQU8sR0FBSSxJQUFJLENBQUM7U0FDL0I7SUFDRixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksS0FBSztRQUNYLE9BQU87WUFDTixXQUFXLEVBQUUsSUFBSSxDQUFDLFdBQVc7WUFDN0IsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ25CLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTztZQUNyQixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO1NBQ3JCLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==